import type { WalletProviderEnum } from '@dynamic-labs/sdk-api-core';

import type { Chain } from '../../../chain';
import { normalizeWalletNameWithChain } from '../normalizeWalletNameWithChain';

type FormatWalletProviderKeyParams = {
  chain: Chain;
  displayName: string;
  suffix?: string;
  walletProviderType: WalletProviderEnum;
};

/**
 * Assembles the wallet provider key from the wallet name, chain, and wallet provider type.
 *
 * The suffix is optional and can be used to add a uniquely identifying string to the key, which
 * might be necessary for some wallet providers (like Wallet Connect).
 *
 * IMPORTANT: Do NOT add a suffix unless absolutely necessary, as it will cause the wallet account
 * to not be able to find its wallet provider when connecting to a new device (it won't be possible
 * to determine the full key just from the Verified Credential data).
 */
export const formatWalletProviderKey = ({
  suffix,
  chain,
  displayName,
  walletProviderType,
}: FormatWalletProviderKeyParams) => {
  const normalizedNameWithChain = normalizeWalletNameWithChain({
    chain,
    displayName,
  });

  return `${normalizedNameWithChain}:${walletProviderType}${
    suffix ? `:${suffix}` : ''
  }`;
};
